import { notification } from 'antd';
import _ from 'lodash';

export enum Type {
  DataError = '数据异常',
  FieldNotExistInLogic = '逻辑实体中字段不存在，但是页面配置中存在',
  TaskIdNotExist = '任务id不存在',
  IdNotExist = 'id不存在',
  BizComponentNotFind = '业务组件不存在',
}

let array: Array<[string, string | undefined]> = [];
let immediate: any = null;

/**
 * 异常信息提示，自动去重
 */
export function error(type: Type, description?: string | object) {
  array.push([type, _.isObject(description) ? JSON.stringify(description) : description]);
  immediate && clearImmediate(immediate);
  immediate = setImmediate(() => {
    array = _.uniqBy(array, (x) => x[0] + x[1]);
    for (const x of array) {
      notification.warn({
        message: x[0],
        description: x[1],
      });
    }
    array = [];
  });
}

/**
 * 警告
 */
export function warn(type: Type, description: string | object) {
  console.warn(`${type}: ${_.isObject(description) ? JSON.stringify(description) : description}`);
}


export default { Type, error, warn };
